<template>
<router-link :to="{ name: 'entity', params: { id: entity.id } }">{{nameFormatted(entity.name, formatZ)}}</router-link>
</template>

<script>
import {
  nameFormatted
} from '@/util/helpers';
export default {
  name: "EntityZ",
  props: ["entity", "format"],
  computed: {
    formatZ() {
      return this.format ? this.format : "full"
    }
  },
  methods: {
    nameFormatted
  }
};
</script>
